import requireContext from "require-context.macro";
import { dynamicResource } from "./dynamicResource";

const LogoSrc = dynamicResource(requireContext(".", false, /Logo(.*)\.svg$/));

export const Logo = (props) => {
  return <img src={LogoSrc} alt="" {...props} />;
};
